/**
 * Card identifiers used throughout the emotion detector workflow
 */
export const CARD_IDS = {
	INTRO: 'intro',
	CAPTURE: 'capture',
	SELECTION: 'selection',
	RECOMMENDATIONS: 'recommendations',
	CHAT: 'chat',
} as const;

export type CardId = (typeof CARD_IDS)[keyof typeof CARD_IDS];

/**
 * Timing constants for card carousel and animations
 */
export const CARD_TIMING = {
	SCROLL_DELAY: 50,
	CARD_REVEAL_DELAY: 200,
	CHAT_REVEAL_DELAY: 50,
	CHAT_SCROLL_DELAY: 100,
	INITIAL_CENTER_DELAY: 100,
} as const;

/**
 * Carousel interaction constants
 */
export const CAROUSEL = {
	DRAG_SENSITIVITY: 2,
} as const;

/**
 * Default and error messages for emotion chat
 */
export const CHAT_MESSAGES = {
	DEFAULT_GREETING: 'Hello! How can I help you today?',
	ERROR_SENDING: '❌ Error sending message. Please try again.',
	ERROR_STARTING: '❌ Error starting conversation. Please try again.',
} as const;

/**
 * Status messages for emotion detection workflow
 */
export const DETECTION_STATUS = {
	INITIAL: 'No emotion captured yet.',
	WEBCAM_ERROR: 'Unable to access webcam. Please check permissions and try again.',
	CAPTURING: '📸 Capturing images...',
	ANALYZING: '🤖 Analyzing emotion...',
} as const;

/**
 * Image capture constants
 */
export const IMAGE_CAPTURE = {
	FORMAT: 'image/png',
} as const;

/**
 * Recommendations filtering constants
 */
export const RECOMMENDATIONS = {
	MIN_ITEMS: 3,
	SHUFFLE_RANDOM_FACTOR: 0.5,
} as const;

/**
 * Content type constants
 */
export const CONTENT_TYPES = {
	AUDIO: 'audio',
	VIDEO: 'video',
	PROGRAM: 'program',
} as const;

/**
 * API constants
 */
export const API_HEADERS = {
	DEVICE_CAPABILITIES: 'v1;signedCookie;streamOnly',
} as const;

/**
 * Journal storage constants
 */
export const STORAGE_KEYS = {
	EMOTION_NOTES: 'emotionNotes',
	PASSWORD_UNLOCKED: 'emotion-detector-unlocked',
} as const;

export const NOTE_KEY_PREFIX = 'note-';

/**
 * Password protection constants
 */
export const PASSWORD = {
	CORRECT: 'calm2025',
	ERROR_INCORRECT: 'Incorrect password.',
} as const;
